import "./index.scss";

export function SwitchUnitButton(props: React.PropsWithChildren<{ onClick?: () => void }>) {
    return (
        <div className="switch-unit-button flex-row flex-row--center-center" onClick={props.onClick}>
            {props.children}
        </div>
    );
}